module.exports = __webpack_public_path__ + "img/setting_btn.25f9c924.png";